module.exports = __webpack_public_path__ + "img/netherlands.0432874a.svg";